module.exports = __webpack_public_path__ + "img/adulto23.5a716508.jpg";